import Head from 'next/head'
import React, { useState, useEffect } from 'react'

export default function CookiePolicy() {
  return (
    <>
      <Head>
        <title>Cookie Policy - OpenSpeech</title>
      </Head>

      <div className="px-6 pt-16 lg:px-8">
        <div className="mx-auto max-w-4xl">
          <h1 className="mx-auto max-w-4xl text-center text-5xl font-bold tracking-tight">
            Cookie Policy
          </h1>
        </div>
      </div>

      <div className="px-6 py-16 lg:px-8">
        <div className="mx-auto max-w-4xl">
          <h2 className="mx-auto max-w-4xl text-3xl font-bold tracking-tight">
            What are cookies?
          </h2>

          <p className="mx-auto mt-4 max-w-4xl">
            Cookies are small text files that are stored on your computer or
            mobile device when you visit a website. They allow the website to
            remember your actions and preferences over a period of time, so you
            don’t have to keep re-entering them whenever you come back to the
            site or browse from one page to another.
          </p>

          <p className="mx-auto mt-4 max-w-4xl">
            Cookies can be set by the owner of the website or in some cases by
            third party services the website owner allows to present other
            information, run content or provide other functionality such as
            analytics. The information collected by cookies does not personally
            identify you; it includes general information about your computer
            settings, your connection to the Internet e.g. operating system and
            platform, IP address, your browsing patterns and timings of browsing
            on the Website and your location.
          </p>

          <p className="mx-auto mt-4 max-w-4xl">
            Most internet browsers accept cookies automatically, but you can
            change the settings of your browser to erase cookies or prevent
            automatic acceptance if you prefer. These links explain how you can
            control cookies via your browser - remember that if you turn off
            cookies in your browser then these settings apply to all websites
            not just this one:
          </p>

          <ul className="mx-auto mt-4 max-w-4xl list-inside list-disc">
            <li className="mx-auto mt-4 max-w-4xl">
              <a href="https://support.google.com/chrome/answer/95647?hl=en-GB">
                Chrome
              </a>
            </li>

            <li className="mx-auto mt-4 max-w-4xl">
              <a href="https://support.mozilla.org/en-US/kb/enable-and-disable-cookies-website-preferences">
                Firefox
              </a>
            </li>

            <li className="mx-auto mt-4 max-w-4xl">
              <a href="https://support.microsoft.com/en-us/help/17442/windows-internet-explorer-delete-manage-cookies">
                Internet Explorer
              </a>
            </li>

            <li className="mx-auto mt-4 max-w-4xl">
              <a href="https://support.apple.com/en-gb/guide/safari/manage-cookies-and-website-data-sfri11471/mac">
                Safari
              </a>
            </li>
          </ul>

          <p className="mx-auto mt-4 max-w-4xl">
            The following types of cookies are used on this site:
          </p>

          <h2 className="mx-auto mt-4 max-w-4xl text-3xl font-bold tracking-tight">
            Essential Cookies
          </h2>

          <p className="mx-auto mt-4 max-w-4xl">
            These cookies are necessary for the website to function and cannot
            be switched off in our systems. They are usually only set in
            response to actions made by you which amount to a request for
            services, such as setting your privacy preferences, logging in or
            filling in forms. You can set your browser to block or alert you
            about these cookies, but some parts of the site will not then work.
            These cookies do not store any personally identifiable information.
          </p>

          <h2 className="mx-auto mt-4 max-w-4xl text-3xl font-bold tracking-tight">
            Performance Cookies
          </h2>

          <p className="mx-auto mt-4 max-w-4xl">
            These cookies help us track and tally visits and traffic sources so
            that we can measure and optimize the site's performance. They enable
            us to determine which pages are the most and least frequented, and
            observe how visitors interact with the site. The data gathered by
            these cookies is consolidated, making it anonymous. If you opt not
            to enable these cookies, we won't be aware of your visit to the site
            and will lack the necessary data to enhance its performance.
          </p>

          <h2 className="mx-auto mt-4 max-w-4xl text-3xl font-bold tracking-tight">
            Targeting Cookies
          </h2>

          <p className="mx-auto mt-4 max-w-4xl">
            These cookies might be placed on our site by our advertising
            partners. They could be utilized by these companies to compile a
            profile of your interests and present you with pertinent ads on
            other websites. While they don't store personal information
            directly, they operate by uniquely identifying your browser and
            internet-connected device. Should you choose not to accept these
            cookies, you may encounter advertising that is less tailored to your
            preferences.
          </p>

          <h2 className="mx-auto mt-4 max-w-4xl text-3xl font-bold tracking-tight">
            Social Media Cookies
          </h2>

          <p className="mx-auto mt-4 max-w-4xl">
            These cookies are implemented by various social media services
            integrated into the site to allow you to share our content with your
            peers and networks. They have the ability to track your browser
            activity across different sites and accumulate a profile of your
            interests. This might influence the content and communications you
            encounter on other sites you browse. If you decide against enabling
            these cookies, you might be unable to utilize or view these sharing
            functionalities.
          </p>

          <h2 className="mx-auto mt-4 max-w-4xl text-3xl font-bold tracking-tight">
            How do we use cookies?
          </h2>

          <p className="mx-auto mt-4 max-w-4xl">
            We use cookies to track your use of our website. This enables us to
            understand how you use the site and track any patterns with regards
            how you are using our website. This helps us to develop and improve
            our website as well as products and / or services in response to
            what you might need or want.
          </p>

          <p className="mx-auto mt-4 max-w-4xl">Cookies are either:</p>


        </div>
      </div>
    </>
  )
}
